var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoundaryAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8326_2299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_8326_2299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8C18.7761 8 19 7.77636 19 7.5V5.5C19 5.22364 18.7761 5 18.5 5H16.5C16.2239 5 16 5.22364 16 5.5V6H8V5.5C8 5.22364 7.77615 5 7.5 5H5.5C5.22385 5 5 5.22364 5 5.5V7.5C5 7.77636 5.22385 8 5.5 8H6V16H5.5C5.22385 16 5 16.2236 5 16.5V18.5C5 18.7764 5.22385 19 5.5 19H7.5C7.77615 19 8 18.7764 8 18.5V18H16V18.5C16 18.7764 16.2239 19 16.5 19H18.5C18.7761 19 19 18.7764 19 18.5V16.5C19 16.2236 18.7761 16 18.5 16H18V8H18.5ZM17 16H16.5C16.2239 16 16 16.2236 16 16.5V17H8V16.5C8 16.2236 7.77615 16 7.5 16H7V8H7.5C7.77615 8 8 7.77636 8 7.5V7H16V7.5C16 7.77636 16.2239 8 16.5 8H17V16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 11.0256L14 10.6395V9.5C14 8.39724 13.1028 7.5 12 7.5C10.8972 7.5 10 8.39724 10 9.5V10.6395L8.84177 11.0256C8.63771 11.0938 8.5 11.2847 8.5 11.5C8.5 15 11.68 16.384 11.68 16.384C11.7728 16.4614 11.8863 16.5 12.0001 16.5C12.1138 16.5 12.2273 16.4614 12.3201 16.384C12.3201 16.384 15.5001 15 15.5001 11.5C15.5001 11.2847 15.3624 11.0937 15.1583 11.0256H15.1582ZM12.5 13.5C12.5 13.7762 12.2761 14 12 14C11.7238 14 11.5 13.7762 11.5 13.5V13C11.5 12.7239 11.7238 12.5 12 12.5C12.2761 12.5 12.5 12.7239 12.5 13V13.5ZM13 10.3063L12.1581 10.0257C12.1066 10.0086 12.0533 10 12 10C11.9466 10 11.8933 10.0086 11.8417 10.0257L11 10.3063V9.50004C11 8.94853 11.4485 8.50004 12 8.50004C12.5515 8.50004 13 8.94853 13 9.50004V10.3063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8326_2299",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF598"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8326_2299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundaryAlert);
export default __webpack_public_path__ + "static/media/boundary_alert.472b9c9513c1c994f90b37042893a4ce.svg";
export { ForwardRef as ReactComponent };